<template>
  <div class="main-body">
    <div class="header">点单已评价</div>
    <div class="out">

      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column prop="activityContentName" label="活动内容"  fixed></el-table-column>

        <el-table-column prop="practiceSiteName" label="实践中心" ></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" label="申请时间"></el-table-column>

        <el-table-column prop="volunteerTeamName" label="志愿队伍" ></el-table-column>
        <el-table-column prop="passTime" :formatter="timefilter" label="指派时间"></el-table-column>

        <el-table-column prop="receiveTime" :formatter="timefilter" label="接收时间"></el-table-column>

        <el-table-column prop="activityAddress" label="活动地址"></el-table-column>
        <el-table-column prop="activityStartTime" :formatter="timefilter" label="开始时间"></el-table-column>
        <el-table-column prop="activityEndTime" :formatter="timefilter" label="结束时间"></el-table-column>

        <el-table-column prop="evaluate" label="评价"></el-table-column>
        <el-table-column prop="evaluateTime" :formatter="timefilter" label="评价时间"></el-table-column>
        <el-table-column prop="isShow" label="对外展示">
          <template slot-scope="scope">
            <span v-if="scope.row.isShow ==1">展示</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" @click="handlePhoto(scope.$index, scope.row)">活动记录</el-button>

            <el-button size="mini" v-if="scope.row.isShow==0" @click="handleShow(scope.$index, scope.row)">对外展示</el-button>
            <el-button size="mini" v-if="scope.row.isShow==1" @click="handleShow(scope.$index, scope.row)">对外隐藏</el-button>


          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

    <Photo ref="myPhoto" v-show="showModalPhoto" v-on:closePhoto="closePhoto"></Photo>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";
import Photo from "./Photo";

import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",

  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,




      showModalAdd:false,
      showModalEdit:false,
      showModalPhoto:false,

      th:0,

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight+50;
  },
  components:{
    Add,Edit,Photo
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val+50;
    },
  },
  methods:{


    timefilter(row,index,column){
      return timefilters(column).slice(0,16)
    },

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },




    search(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/PageForCenter',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          status:6,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    handlePhoto(index, row) {
      this.$refs.myPhoto.init(row);
      this.showModalPhoto = !this.showModalPhoto;
    },
    closePhoto:function(){
      this.showModalPhoto = !this.showModalPhoto;
    },

    handleShow(index,row){

      let tag = 1;
      let title = "确定要显示吗";
      if(row.isShow == 1){
        tag = 0;
        title = "确定要隐藏吗";
      }

      this.$confirm(title, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setShow(row.activityOrderCode,tag);
      }).catch(e=>e)

    },

    setShow(activityOrderCode,isShow){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'ActivityOrder/Show',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          activityOrderCode:activityOrderCode,
          isShow:isShow,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.getList();
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>

</style>
